/**
 * Global Ask AI shell — keeps the Guide drawer mounted once and exposes
 * `openAskAi()` to the header, sidebar and legacy `/ask-ai` redirects.
 *
 * Behind the `ask_ai` customer feature flag (off by default; operators switch it
 * per customer / org / tenant / user in the admin portal) while the assistant
 * (ask-ai-api) rolls out. ask-ai-api checks the same flag on every question, so
 * this gate decides what is SHOWN, not what is allowed. Gated HERE, once, rather
 * than at each door: while the flag is off the drawer is not mounted,
 * `openAskAi` does nothing, and `enabled` tells the doors to stay out of sight.
 */
import * as React from "react";

export interface AskAiContextValue {
  /** Whether Ask AI is rolled out to this session. Render no door when false. */
  enabled: boolean;
  openAskAi: () => void;
}

export const AskAiContext = React.createContext<AskAiContextValue | null>(null);

export function useAskAi(): AskAiContextValue {
  const ctx = React.useContext(AskAiContext);
  if (!ctx) {
    throw new Error("useAskAi must be used within AskAiProvider");
  }
  return ctx;
}
